import React from 'react';
import SwitchBox from '../SwitchBox';
import TextInputStyles from './TextInput.module.css';

const TextInput = React.forwardRef(({
	type = 'text',
	label,
	icon,
	placeholder,
	value,
	onChange,
	onKeyDown,
	onKeyPress,
	disabled = false,
	errorMessage,
	style,
	maxLength,
	autoFocus = false,
	switchBox = false,
	switchChecked = false,
	switchOnChange
}, ref) => {
	return (
		<div className={TextInputStyles.text_input}>
			{label && (
				<label htmlFor={label} data-testid='text-box-label'>
					{label}
				</label>
			)}
			<div className={TextInputStyles.text_input_box}>
				<div className={TextInputStyles.input_box} style={style}>
					<svg data-testid='text-box-icon'>
						<use xlinkHref={`/assets/sprite.svg#icon-${icon}`} />
					</svg>
					<input
						ref={ref}
						type={type}
						placeholder={placeholder}
						name={label}
						value={value}
						onChange={onChange}
						onKeyDown={onKeyDown}
						onKeyPress={onKeyPress}
						disabled={disabled}
						maxLength={maxLength}
						autoFocus={autoFocus}
						data-testid='text-box'
					/>
				</div>
				{switchBox && <SwitchBox checked={switchChecked} onChange={switchOnChange} />}
			</div>
			{errorMessage && <p>{errorMessage}</p>}
		</div>
	);
});

export default TextInput;
